ClickElseWhereMixin = require 'mixins/click-else-where'

###
# Компонент селекта
###
App.SmSelectComponent = Em.Component.extend ClickElseWhereMixin,
  classNames: 'sm-select'

  # имеется в виду, что свойства могут изменяться напрямую компонентом
  # использовать 'one-way', чтобы реагировать на новый стиль
  propBehaviour: 'two-way'

  classNameBindings: [
    'isOpen',
    'disabled'
  ]
  isOpen: false

  selectedOption: null
  labelPath: ''
  labelValue: null

  label: null
  hasSearch: false

  disabled: false

  placeholder: (->
    placeholderTranslation = @get('placeholderTranslation')
    return unless placeholderTranslation
    console.log placeholderTranslation
    Em.I18n.t placeholderTranslation
  ).property('placeholderTranslation')

  selectedLabel: (->
    return @get('labelValue') if @get('labelValue')
    label = @get('label')
    return label if label

    @get('selectedOption' + @get('labelPath'))
  ).property(
    'label',
    'labelPath',
    'selectedOption' )

  initAvailableOptions: (->
    @set('availableOptions', [])
  ).on('init')

  setClickInput: (->
    $smSelectValue = @$().find('.sm-select-value')
    $smSelectValue.on('click', ((e) => @toggleProperty('isOpen'); e.stopPropagation()))
  ).on('didInsertElement')

  unsetClickInput: (->
    $smSelectValue = @$().find('.sm-select-value')
    $smSelectValue.off('click')
  ).on('willDestroyElement')

  click: ->
    @set('isOpen', true)

  onClickElsewhere: ->
    @set('isOpen', false) if @get('isOpen')

###
# Компонент одной опции селекта
###
App.SmSelectOptionComponent = Em.Component.extend
  classNames: 'sm-select-option'
  selectedOptionBinding: 'parentView.selectedOption'
  isOpenBinding: 'parentView.isOpen'

  register: (->
    @get('parentView.availableOptions').pushObject(@get('option'))
  ).on('didInsertElement')

  unregister: (->
    @get('parentView.availableOptions').pushObject(@get('option'))
  ).on('willDestroyElement')

  isActive: (->
    @get('option') is @get('selectedOption')
  ).property('option', 'value')

  click: (e)->
    if @get('parentView.propBehaviour') is 'two-way'
      v = @get('option')
      v = @get('option'+@get('parentView.labelSetPath')) if @get('parentView.labelSetPath')
      @set('selectedOption', v)

    @set('isOpen', false)
    e.stopPropagation()
    Em.run.next =>
      @get('parentView')?.sendAction('onOptionSelected', @get('option'))

